// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3RkEB","comment":"styles_comment__2uO5j"};